import React, { useContext, useEffect, useState } from "react";
import { CommonModal, Spinner } from "../../../../AbstractElements";
import { Row, Col, Form } from "reactstrap";
import { endTrip, startTrip } from "../../../../Services/Trip.service";
import { showAlert } from "../../../../Services/Shared.service";
import Success from "../../../../../src/assets/images/success.png"
import LocationSlash from "../../../../../src/assets/images/slash-over-location-pin.jpg"
import { fetchLocation } from "../../../../Services/Booking.service";
import { useController, useForm } from "react-hook-form";
import CustomAutoSuggest from "../../../../CommonElements/CustomAutoSuggest";
import { MapPin } from "react-feather";
import SharedDataContext from "../../../../_helper/SharedData";
import Select from "react-select";
import CustomSelect from "../../../../CommonElements/CustomSelect";


const VendorStartTripConformation = ({ Large, title, LargeModaltoggle, tripObj }) => {
  const {
    airportData,
  } = useContext(SharedDataContext);
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [airportCityData, setAirportCityData] = useState([]);

  useEffect(() => {
    let array = [];
    if (tripObj.rideType === "AirportPickup" && tripObj.serviceCityId) {
      airportData.forEach((element) => {
        if (element.serviceCityId == tripObj.serviceCityId) {
          array.push({
            value: element,
            label: element.name,
          });
        }
      });
    }
    setAirportCityData(array);
  }, [tripObj])

  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      locationAddressDropdown: "",
      locationAddress: "",
    },
  });

  const locationAddressField = useController({
    name: "locationAddressDropdown",
    control,
  }).field;

  const handleLocationSelectChange = (data) => {
    locationAddressField.onChange(data.value);
  };

  useEffect(() => {
    if (locationAddressField.value?.address) {
      setValue("locationAddress", locationAddressField.value?.address);
    } else if (locationAddressField.value) {
      let obj = {
        key: null,
        isAgentApp: true,
        geoApi: true,
        address: locationAddressField?.value||null,
        requestSource: "TMS"
      }
      fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          locationAddressField.onChange(result.data[0])
        }
      });
    } else {
      setValue("locationAddress", "");
    }
  }, [locationAddressField.value]);

  const getAddressData = async (inputValue) => {
    if (inputValue) {
      let obj = {
        key: inputValue,
        isAgentApp: true,
        geoApi: false,
        address: null,
        requestSource: "TMS"
      }
      return fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element?.address ? element.address : element,
            };
          });
          return data;
        }
        return [];
      });
    }
  };


  const onClickConfirm = () => {
    setIsConfirmed(true)
  }

  console.log("trip obj", tripObj)
  console.log("values",getValues())

  const onClickConfirmWithAddress = () => {
    const values = getValues()
    if (!values.locationAddressDropdown?.lat || !values.locationAddressDropdown?.lat) {
      showAlert("error", "Please select a valid location")
      return;
    }
    let obj = {
      tripId: tripObj.id,
      driverId: tripObj.driverId,
      pickUpLat: values.locationAddressDropdown.lat,
      pickUpLng: values.locationAddressDropdown.lng,
      pickupAddress:tripObj.pickUpAddress
    }
    startTrip(obj).then(() => {
      showAlert("success", "Trip started Successfully")
      setIsConfirmed(false)
      reset()
      LargeModaltoggle()
    }).catch((err) => {
      showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong.")
    })
  }


  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={() => {
        setIsConfirmed(false)
        reset()
        LargeModaltoggle()
      }}
      size="lg"
    >
      <Row className="driver-push-notification">
        {isConfirmed ? (
          <Form onSubmit={handleSubmit(onClickConfirmWithAddress)}>
            <Col xl="12" className="push-botification-body">
              <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                <MapPin size={"70"} style={{ marginBottom: "15px" }} />
                {
                  tripObj.rideType === "AirportPickup" ? (
                    <>
                      <div>Select pickup location manually.</div>
                      <div style={{ margin: "15px 0px", width: "70%" }}>
                        <CustomSelect
                          className="service-select"
                          classNamePrefix="select"
                          isClearable={false}
                          isSearchable={false}
                          // defaultValue={}
                          value={airportCityData.find((element) => {
                            return element?.value?.name == locationAddressField?.value?.name;
                          })}
                          onChange={handleLocationSelectChange}
                          placeholder="Select Airport"
                          options={airportCityData}
                        />
                        <span style={{ color: "red" }}>{errors?.locationAddressDropdown?.message}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>Enter pickup location manually.</div>
                      <div style={{ margin: "15px 0px", width: "70%" }}>
                        <CustomAutoSuggest
                          id={"Location"}
                          handleSelectChange={handleLocationSelectChange}
                          options={getAddressData}
                          placeholder="Enter location"
                          registerName={"locationAddress"}
                          register={register}
                          isClearable={true}
                          setValue={setValue}
                          watch={watch}
                          inputProps={{
                            required: {
                              value: true,
                              message: "Location is required",
                            },
                          }}
                          dependentRegisterName={"locationAddressDropdown"}
                        />
                        <span style={{ color: "red" }}>{errors?.locationAddress?.message}</span>
                      </div>
                    </>
                  )
                }
              </div>
            </Col>
            <Col xl="12" className="push-notification-footer">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  setIsConfirmed(false)
                  reset()
                  LargeModaltoggle()
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                style={{ marginLeft: "20px" }}
              >
                Confirm
              </button>
            </Col>
          </Form>
        ) : (
          <>
            <Col xl="12" className="push-botification-body">
              <div className="text-center">Are you sure to start this trip manually ?</div>
            </Col>
            <Col xl="12" className="push-notification-footer">
              <button
                className="btn btn-primary"
                type="submit"
                onClick={() => {
                  setIsConfirmed(false)
                  LargeModaltoggle()
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                style={{ marginLeft: "20px" }}
                onClick={() => onClickConfirm()}
              >
                Confirm
              </button>
            </Col>
          </>
        )}
      </Row>
    </CommonModal >
  );
};

export default VendorStartTripConformation;
